<div class="content-tabs">
  <ex-button [type]="currentUrl.includes(articleUrl) ? 'primary' : 'secondary'"
             [variant]="currentUrl.includes(articleUrl) ? 'raised' : 'tonal'"
             size="medium" icon="newspaper-fill"
             [routerLink]="['./'+articleUrl]"
  >
    {{'header.article-tab' | translate}} ({{nbArticle?.toLocaleString()}})
  </ex-button>
  <ex-button [type]="currentUrl.includes(adminDocUrl) ? 'primary' : 'secondary'"
             [variant]="currentUrl.includes(adminDocUrl) ? 'raised' : 'tonal'"
             size="medium" icon="read-cv-logo-fill"
             [routerLink]="['./'+adminDocUrl]"
  >
    {{'header.admin-doc-tab' | translate}} ({{nbAdminDoc?.toLocaleString()}})
  </ex-button>
  <ex-button [type]="currentUrl.includes(impacterUrl) ? 'primary' : 'secondary'"
             [variant]="currentUrl.includes(impacterUrl) ? 'raised' : 'tonal'"
             size="medium" icon="users-three-fill"
             [routerLink]="['./'+impacterUrl]"
  >
    {{'header.impacters' | translate}} ({{nbImpacter?.toLocaleString()}})
  </ex-button>
</div>
